import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import CustomerHead from '../../components/customer/CustomerHead';
import { CommercialServiceList } from '../../components/customer/ConsultList';

export default function CustomerCommercial(){

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1025);

  return (
    <ServiceWrap>
      <CustomerHead title="Commercial Services" back={true}/>
      <main className="content">
        <section className="visual-sec">
          {!isMobile && (
            <img src="https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/background/commercial_visual.webp" alt="visual" />
          )}
          {isMobile && (
            <img src="https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/background/m_commercial.webp" alt="visual" />
          )}
        </section>
        <section className="service-wrap">
          <div className="inner">
            <div className="service-desc">
              <p>we understand that pests can pose a serious threat to businesses, affecting operations, reputation, and customer satisfaction. Our Commercial Pest Control Services are designed to provide effective, long-term pest management for all types of commercial spaces. As the first Korean pest control company in India, partnered with Vietnam, we bring the latest pest control techniques and advanced solutions to ensure a safe, clean, and pest-free environment for your business.</p>
              <p>Pests in commercial spaces can cause property damage, contamination, and health risks for employees and customers. Issues like rodent infestations, cockroach activity, and ant trails can lead to health code violations and customer complaints, ultimately affecting your business's reputation and revenue. Our commercial pest control services are tailored to address these issues effectively while ensuring minimal disruption to your daily operations.</p>
            </div>
            <div className="service-list" id="service-list">
              {CommercialServiceList.map(({ title, desc, link }, idx) => (
                <Link to={link} key={idx} className={`service-item item-${idx+1}`} category="commercial">
                  <div className="list-in">
                    <strong>{title}</strong>
                    <p>{desc}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
        <section className="approach-visual">
          <div className="visual-img">
            {isMobile && (
              <img src="https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/service/commercial_bg.webp" alt="approach-img" />
            )}
          </div>
          <div className="visual-desc">
            <div className="desc-head">
              <strong>IREP Approach</strong>
              <p>We follow a specialized IREP Approach to ensure effective pest management:</p>
            </div>
            <div className="desc-content">
              <img src="https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/service/approach-img.webp" alt="arep" />
            </div>
          </div>
        </section>
        <section className="approach-info">
          <div className="inner">
            <strong  className="info-tit">At UST Pest Services, we follow the <em>IREP</em> <span>(Identifying, Reducing, Eliminating, Preventing)</span> approach, a systematic method to ensure effective and long-term pest control.</strong>
            <ul className="info-list">
              <li className="info-item">
                <strong>1. Identifying (I) - Identifying Pest Entry Points</strong>
                <p>The first step is to inspect and identify how pests are entering your space. This includes checking for gaps in doors, cracks in walls, drainage openings, and ventilation gaps. We do not seal these points but provide a detailed report on the areas that need to be fixed to prevent pest entry.</p>
              </li>
              <li className="info-item">
                <strong>2. Reducing (R) - Reducing Pest Attractions</strong>
                <p>The first step is to inspect and identify how pests are entering your space. This includes checking for gaps in doors, cracks in walls, drainage openings, and ventilation gaps. We do not seal these points but provide a detailed report on the areas that need to be fixed to prevent pest entry.</p>
              </li>
              <li className="info-item">
                <strong>3. Eliminating (E) - Eliminating Existing Pests</strong>
                <p>The first step is to inspect and identify how pests are entering your space. This includes checking for gaps in doors, cracks in walls, drainage openings, and ventilation gaps. We do not seal these points but provide a detailed report on the areas that need to be fixed to prevent pest entry.</p>
              </li>
              <li className="info-item">
                <strong>4. Preventing (P) - Preventing Future Infestations</strong>
                <p>The first step is to inspect and identify how pests are entering your space. This includes checking for gaps in doors, cracks in walls, drainage openings, and ventilation gaps. We do not seal these points but provide a detailed report on the areas that need to be fixed to prevent pest entry.</p>
              </li>
            </ul>
            <p className="info-foot">For safe and expert pest control services, trust UST Pest Services - bringing advanced Korean techniques to India for a clean and pest-free space!</p>
          </div>
        </section>
      </main>
    </ServiceWrap>
  )
}

const ServiceWrap = styled.div`
  position: relative;
  background: #F9FAFB;
  
  .content {
    position:relative;
    padding: 20px 20px 80px 20px;

    .visual-sec {
      position: relative;
      width: 100%;

      img {
        width: 100%;
      }
    }

    .service-wrap {
      position: relative;
      padding: 100px 0;

      .service-desc {
        position: relative;
        text-align: center;

        p {
          display: block;
          font-weight: 400;
          font-size: 24px;
          line-height: 1.5;
          color: #000;
        }

        p + p {
          margin-top: 60px;
        }
      }

      .service-list {
        margin-top: 60px;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        gap: 60px 120px;

        .service-item {
          position: relative;
          width: calc(33.33% - 80px);
          min-height: 305px;
          padding: 20px;
          border-radius: 30px;
          border: 5px solid #fff;
          background: #0072B9;
          filter: drop-shadow(10px 10px 1px rgba(0, 0, 0, 0.2));
          text-align: center;

          &:hover::before {
            z-index: 1;
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.75);
            border-radius: 30px;
          }

          ${[...Array(9)].map(
                  (_, i) => css`
              &.item-${i + 1}:hover {
                background: url("https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/space/space_0${
                          i + 1
                  }.webp") no-repeat;
                background-size: cover;
              }
            `
          )}
          .list-in {
            z-index: 2;
            position: relative;

            strong {
              font-weight: 600;
              font-size: 24px;
              color: #fff;
            }

            p {
              margin-top: 15px;
              display: block;
              font-weight: 400;
              font-size: 18px;
              line-height: 1.5;
              color: #fff;
            }
          }
        }
      }
    }

    .approach-visual {
      position: relative;
      display: flex;

      .visual-img, .visual-desc {
        flex: 1;
      }

      .visual-img {
        height: auto;
        background: url("https://ust-india.s3.ap-northeast-2.amazonaws.com/disinfection/renewal/service/commercial_bg.webp") 50% 50% no-repeat;
      }

      .visual-desc {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 50px 0;
        gap: 60px 0;

        .desc-head {
          position: relative;
          text-align: center;

          strong {
            display: inline-block;
            font-weight: 400;
            font-size: 48px;
            padding-bottom: 10px;
            border-bottom: 1px solid #000;
          }

          p {
            margin-top: 15px;
            display: block;
            font-size: 24px;
            line-height: 1.5;
            color: #000;
          }
        }

        .desc-content {
          position: relative;
          text-align: center;

          img {
            max-width: 75%;
          }
        }
      }
    }

    .approach-info {
      position: relative;
      padding: 100px 0;

      .info-tit {
        font-weight: 400;
        font-size: 24px;
        line-height: 1.5;
        color: #000;

        em {
          font-weight: 700;
          color: #0072B9;
        }

        span {
          font-weight: 700;
        }
      }

      ul {
        margin-top: 50px;

        li {
          position: relative;

          strong {
            font-weight: 700;
            font-size: 24px;
            color: #0072B9;
          }

          p {
            font-weight: 400;
            font-size: 24px;
            line-height: 1.5;
            color: #000;
          }
        }

        li + li {
          margin-top: 50px;
        }
      }

      .info-foot {
        margin-top: 50px;
        display: block;
        font-weight: 400;
        font-size: 24px;
        line-height: 1.5;
        color: #000;
      }
    }

    @media only screen and (max-width: 1480px) {
      .service-wrap {
        .service-list {
          gap: 60px 60px;

          .service-item {
            width: calc(33.33% - 40px);
          }
        }
      }
    }

    @media only screen and (max-width: 1024px) {
      .service-wrap {
        padding: 40px 0 80px;

        .service-desc {
          text-align: left;

          p {
            font-size: 18px;
          }

          p + p {
            margin-top: 30px;
          }
        }

        .service-list {
          margin-top: 30px;
          display: block;

          .service-item {
            position: relative;
            display: block;
            width: 90%;
            margin: 0 auto;
            min-height: 200px;

            strong {
              font-weight: 600;
              font-size: 24px;
              color: #fff;
            }

            p {
              margin-top: 15px;
              display: block;
              font-weight: 400;
              font-size: 18px;
              line-height: 1.5;
              color: #fff;
            }
          }

          .service-item + .service-item {
            margin-top: 60px;
          }
        }
      }

      .approach-visual {
        position: relative;
        padding: 50px 20px;
        background: rgba(217, 217, 217, 0.7);
        display: block;

        .visual-img, .visual-desc {
          width: 100%;
        }

        .visual-img {
          height: auto;
          background: none;

          img {
            width: 100%;
          }
        }

        .visual-desc {
          margin-top: 25px;
          padding: 0;
          gap: 30px 0;

          .desc-head {
            position: relative;
            text-align: center;

            strong {
              font-size: 32px;
            }

            p {
              font-size: 16px;
            }
          }

          .desc-content {
            position: relative;
            text-align: center;
          }
        }
      }

      .approach-info {
        position: relative;
        padding: 40px 0;

        .info-tit {
          font-size: 16px;
        }

        ul {
          margin-top: 25px;

          li {
            position: relative;

            strong {
              font-size: 18px;
            }

            p {
              font-size: 16px;
            }
          }

          li + li {
            margin-top: 25px;
          }
        }

        .info-foot {
          margin-top: 25px;
          font-size: 16px;
        }
      }
    }

    @media only screen and (max-width: 640px) {

      .service-wrap {
        .service-list {
          .service-item {
            width: 100%;
          }
        }
      }
    }
  \`
  }
`